import { GetAdminExpensesResponse } from '@orbit/api-types'
import { useAdminFilter } from '@pages/Admin/AdminFilterContext'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseAdminExpensesParams {
	page: number
	pageSize?: number
	/** Search by expense name or trip name; falsy values are omitted. */
	q?: string
}

/**
 * Fetches a page of the admin expenses list (GET /v1/admin/expenses), scoped to the
 * global creation-date range from {@link useAdminFilter} plus page and search term.
 * Previous data is kept while the next page loads. Gated server-side by AdminGuard.
 */
export const useAdminExpenses = ({ page, pageSize, q }: UseAdminExpensesParams) => {
	const { from, to, includeInternal } = useAdminFilter()

	return useQuery<GetAdminExpensesResponse>({
		queryKey: queryKeys.adminExpenses(from, to, page, pageSize, q, includeInternal),
		queryFn: async () => {
			const response = await api.get<GetAdminExpensesResponse>('/admin/expenses', {
				params: { from, to, page, pageSize, q: q || undefined, includeInternal: includeInternal || undefined },
			})
			return response.data
		},
		placeholderData: keepPreviousData,
	})
}
